import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Lang } from './types';

const initialLang: Lang = 'ja';

const LanguageContext = createContext<{ lang: Lang; setLang: React.Dispatch<React.SetStateAction<Lang>>; }>({
    lang: initialLang, setLang: () => { }
});

export const LanguageContextProvider: React.FC<{ children?: ReactNode }> = ({ children }) => {
    const [lang, setLang] = useState<Lang>(initialLang);
    return (
        <LanguageContext.Provider value={{ lang, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
};


export const useLang = () => useContext(LanguageContext);
